const state = {
    modalData: null,
    mainComponent: "",

    selectedAddressId: null,
    selectedDateId: null,
    selectedTimeId: null,

    isInitialAddressesFetch: true,
    isInitialDatesFetch: true,
    isInitialTimesFetch: true,

    courierAddresses: [],
    pickupAddresses: [],
    dates: [],
    times: [],

    isAddressesDisabled: true,
    isDatesDisabled: true,
    isTimesDisabled: true,

    shopType: "",
    isEmptyCart: true,
    activeAddressesTab: "",
    shownAddressesCount: 1000,
    isAllAddressesShown: false,
    autocompleteValue: "",
    autocompletePostCode: "",
    autocompleteCity: "",
    autocompleteStreet: "",
    datesAndTimesVisible: true,

    datesErrorMessage: false,
    processErrorMessage: false,

    wannaChangeAddress: window.Eshop.options.isLogged,
    autocompleteAddressIsUsed: false,
    switchIsSubmitting: false,

    newAddressChecked: false,
    newAddressData: {
        name: "",
        company: "",
        city: "",
        postCode: "",
        address: "",
        phone: "",
        countryId: 1,
    },
    addressIsSubmitting: false,
    availableCountries: [],
};

export default state;
